function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/jsx-handler-names */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DayPickerSingleDateController } from 'react-dates';
import ClickOutside from 'react-click-outside';
import moment from 'moment';
import CalendarIcon from "../icon-components/calendar";
import LeftPaginationArrow from "../icon-components/left-pagination-arrow";
import RightPaginationArrow from "../icon-components/right-pagination-arrow";

var SingleDateInput =
/*#__PURE__*/
function (_Component) {
  _inherits(SingleDateInput, _Component);

  function SingleDateInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SingleDateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SingleDateInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false
    });

    _defineProperty(_assertThisInitialized(_this), "isOutsideRange", function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      if (minDate && maxDate) return !day.isBetween(minDate, maxDate, 'day', '[]');
      if (minDate) return !day.isSameOrAfter(minDate, 'day');
      if (maxDate) return !day.isSameOrBefore(maxDate, 'day');
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      var focused = _this.state.focused;

      _this.setState({
        focused: !focused
      });

      if (!focused && _this.dateInput) _this.dateInput.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (_this.dateInput) _this.dateInput.focus();

      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      if (_this.dateInput) _this.dateInput.blur();

      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "bindRef", function (ref) {
      _this.dateInput = ref;
    });

    return _this;
  }

  _createClass(SingleDateInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          date = _this$props2.date,
          rest = _objectWithoutProperties(_this$props2, ["name", "date"]);

      var focused = this.state.focused;

      var pickerProps = _objectSpread({
        navPrev: React.createElement(LeftPaginationArrow, null),
        navNext: React.createElement(RightPaginationArrow, null),
        onFocusChange: this.toggle,
        isOutsideRange: this.isOutsideRange,
        date: date,
        focused: focused
      }, rest);

      return React.createElement(ClickOutside, {
        onClickOutside: this.blur
      }, React.createElement("section", {
        className: "DateInput-section"
      }, React.createElement("div", {
        className: "DateInput-container"
      }, React.createElement("input", {
        type: "text",
        ref: this.bindRef,
        name: name,
        value: date && date.format('MM/DD/YYYY'),
        className: "form-control",
        onFocus: this.focus
      }), React.createElement(CalendarIcon, null), focused && React.createElement(DayPickerSingleDateController, pickerProps))));
    }
  }]);

  return SingleDateInput;
}(Component);

_defineProperty(SingleDateInput, "propTypes", {
  name: PropTypes.string.isRequired,
  date: PropTypes.instanceOf(moment),
  minDate: PropTypes.instanceOf(moment),
  maxDate: PropTypes.instanceOf(moment),
  onDateChange: PropTypes.func
});

export { SingleDateInput as default };